import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { CategoryConfigurationInheritedStoreActions, DeviceStoreSelectors } from '@era/stores';
import { isNotUndefined } from '@rocksoft/shared';

@Injectable({ providedIn: 'root' })
export class DeviceConfiguredApplicationsResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DeviceStoreSelectors.selectCurrentDevice).pipe(
      filter(isNotUndefined),
      tap((device) => {
        if (!device.categoryId) {
          return;
        }

        this.store.dispatch(
          CategoryConfigurationInheritedStoreActions.CategoryConfigurationInheritedApiActions.categoryConfigurationInheritedRequested(
            {
              categoryId: device.categoryId,
            }
          )
        );
      }),
      map(() => true),
      first()
    );
  }
}
